import $ from "jquery";
import Moment from "react-moment";

export default {
  locale: "US",
  currency: "$",

  configureLocale(locale, currency, timezone) {
    this.locale = locale;
    this.currency = currency;
    this.timezone = timezone;

    Moment.globalTimezone = timezone;
  },

  getCSRFToken() {
    return $("meta[name='csrf-token']").attr("content");
  }
};
